import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./story-card.m.css";

const CustomQuoteElement = ({ element = {}, shareUrl, cdnImage }) => {
  const authorName = get(element, ["metadata", "attribution"], null);
  const isEntity = get(element, ["metadata", "entity", "photo", "0", "key"], null);
  const authorPhoto = isEntity !== null && "https://" + cdnImage + "/" + isEntity;
  const elementText = get(element, ["metadata", "content"], null);

  return (
    <div className="story-element story-element-text story-element-text-quote">
      {elementText && <blockquote>{elementText}</blockquote>}
      {authorName && (
        <div className="attribution">
          {isEntity && <img className="person-image" src={authorPhoto} alt={authorName} />}
          <span>{authorName}</span>
        </div>
      )}
    </div>
  );
};

CustomQuoteElement.propTypes = {
  element: object,
  shareUrl: string,
  cdnImage: string,
};

const mapStateToProps = (state) => ({
  cdnImage: get(state, ["qt", "config", "publisher-attributes", "cdn_image"], null),
});

export default connect(mapStateToProps, "")(CustomQuoteElement);
